/* global angular, _ */

var ngModule = angular.module('trends');
var ALL_GROUPS = 'all';

ngModule.directive('trSearch', ['$location', 'AjaxList', 'Api', '$q', 'Monitor',
    'Restangular', 'QuerySerializer', '$state', 'HistoricContext', 'SearchBoxManager',
    'Usage', '$timeout', 'TagManager',
    function ($location, AjaxList, Api, $q, Monitor, Restangular, QuerySerializer,
        $state, HistoricContext, SearchBoxManager, Usage, $timeout, TagManager) {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope) {
                /* Required for between dates filter and display */
                scope.calendarMonths = [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                                         'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ];
                scope.monthMapping = _.reduce(scope.calendarMonths, function (accum, value, index) {
                    accum.push({id: index+1, name: value});
                    return accum;
                }, []);

                /* Reinitialize the component to its default state. */
                var reset = function () {
                    scope.facets = null;
                    scope.filters = {};
                    scope.subfilters = {};
                    scope.lastParams = null;

                    scope.params = {
                        filters: {},
                        q: ''
                    };

                    scope.contentLoader.reset(); // TODO Allow Monitor to track multiple promises
                    scope.filterLoader.reset();
                    clearResults();

                    var promise = Api.search_filters.get().then(function (filters) {
                        scope.setFilterGroups(Restangular.stripRestangular(filters));
                    });
                    scope.filterLoader.watch(promise);

                    // Load up any serialized parameters
                    loadParams();
                };

                var loadParams = function () {
                    var loaded = serializer.load();
                    if (loaded.saved_id) {
                        // we're loading a saved search
                        Api.alerts.savedsearch.get(loaded.saved_id).then(function (search) {
                            scope.focus = ALL_GROUPS;

                            var criteria = search.search_criteria;
                            scope.params = {
                                filters: criteria.filters || {},
                                q: criteria.q
                            };
                            SearchBoxManager.setValue(scope.params.q);
                        }, function () {
                            console.log('Failed to load saved search with id: ' + loaded.saved_id);
                        });
                    } else {
                        scope.focus = loaded.focus;
                        scope.params = {
                            filters: loaded.filters || {},
                            q: loaded.q
                        };
                    }

                    SearchBoxManager.setValue(scope.params.q);

                };

                var newSearch = function () {
                    scope.lastParams = angular.copy(scope.params);
                    clearResults();

                    var params = angular.extend({facets: true}, scope.params);
                    var promises = [];
                    var highlights = [];

                    angular.forEach(scope.sources, function (source, category) {
                        var promise = source.load(0, params, true).then(function (results) {
                            if (results.meta.facets) {
                                scope.facets = scope.facets || {};
                                scope.facets[category] = results.meta.facets;
                            }

                            for (var entry=0 ; entry < results.meta.highlights.length ; entry++) {
                                if (!(_.contains(highlights, results.meta.highlights[entry]))) {
                                    highlights.push(results.meta.highlights[entry]);
                                }
                            }
                        });

                        promises.push(promise);
                    });

                    scope.contentLoader.watch($q.all(promises).then(function() {
                        HistoricContext.insert('highlights', highlights, 'session');
                        HistoricContext.save();
                        if (scope.hasCriteria()) {
                            Usage.log('search', { q: scope.params.q || '' });

                            // Log page view and search event
                            TagManager.pageView();

                            // Log result counts
                            angular.forEach(scope.sources, function (v, k) {
                                TagManager.event('result-count', {
                                    category: 'search-' + k,
                                    searchQuery: scope.params.q,
                                    searchFilters: scope.params,
                                    value: v.maxItems
                                });
                            });
                        }
                    }));
                };

                var clearResults = function () {
                    angular.forEach(scope.sources, function (v) {
                        v.reset();
                    });
                };

                scope.hasCriteria = function () {
                    return !!scope.params.q || !angular.equals({}, scope.params.filters);
                };

                var itemCount = function (category, key) {
                    // Return the total if called with no fields
                    if (category === undefined) {
                        var total = 0;
                        for (var category in scope.sources) {
                            total += itemCount(category, key);
                        }
                        return total;
                    }

                    return scope.sources[category][key];
                };

                scope.numCategories = function () {
                    var total = 0;
                    for (var category in scope.sources) {
                        if (!scope.sources[category].isEmptyResult()) {
                            total++;
                        }
                    }
                    return total;
                };

                scope.loadedItems = function (category) {
                    return itemCount(category, 'numItems');
                };

                scope.maxItems = function (category) {
                    return itemCount(category, 'maxItems');
                };

                scope.setFocus = function (focus) {
                    scope.focus = focus;
                    $timeout(function (){
                        $('.first input').focus();
                    });
                };

                scope.emptyQuery = function () {
                    var query = scope.lastParams.q;
                    if (query === null || query === '') {
                        return true;
                    }
                    return false;
                };

                scope.getFacet = function (filter) {
                    var focus = scope.focus;
                    var group = scope.getFilterGroup(filter.group_key);

                    if (group.facet_key) {
                        var facets = scope.facets ? scope.facets[focus] : null;
                        if (facets) {
                            return facets[group.facet_key][filter.id] || null;
                        }
                    }

                    return null;
                };

                scope.isCategoryVisible = function (category) {
                    var focused = (scope.focus === category ||
                        scope.focus === ALL_GROUPS);
                    return scope.loadedItems(category) > 0 && focused;
                };

                scope.getEnd = function (/*category*/) {
                    return scope.focus === ALL_GROUPS ? scope.allNumShown : Number.POSITIVE_INFINITY;
                };

                scope.onPageChanged = function (page, moveDefer, content) {
                    content.moveToPage(page, scope.params, true).then(function () {
                        moveDefer.resolve(page);
                        $timeout(function (){
                            $('.first input').focus();
                        });
                    });
                };

                scope.$watch(SearchBoxManager.getValue, function(newValue) {
                    scope.params.q = newValue;
                }, true);

                scope.$watch(function () {
                    return angular.toJson(scope.params) + scope.focus;
                }, function (before, after) {
                    if (before !== after) {
                        serializer.save(angular.extend({focus: scope.focus}, scope.params));
                    }
                });

                scope.$watch(function () { return $location.search(); }, function (newValue) {
                    var params = scope.params;
                    if (scope.focus) {
                        params.focus = scope.focus;
                    }
                    if (!_.isEqual(newValue, serializer.generate(params))) {
                        loadParams();
                    }
                }, true);

                var serializer = new QuerySerializer({
                    filters: {type: 'object', required: false},
                    focus: {type: 'string', fallback: ALL_GROUPS, required: false},
                    q: {type: 'string', required: false},
                    saved_id: {type: 'number', required: false}
                });

                /* Check if the 'View Trendscape' button should be active */
                scope.isTrendscapeViewable = function () {
                    var categories = scope.getFilterCategories();

                    if(!scope.params.q &&
                        _.isEmpty(categories) &&
                        _.isEmpty(scope.params.filters.pillar) &&
                        _.isEmpty(scope.params.filters.place) &&
                        _.isEmpty(scope.params.filters.region) &&
                        _.isEmpty(scope.params.filters.related_trend)) {
                        return false;
                    }
                    return true;
                };

                scope.launchTrendscape = function () {
                    // Get the full names of the selected countries
                    // var places = _.filter(scope.filters.place.filters, function(x) {
                    //     return _.contains(scope.params.filters.place, x.code);
                    // });

                    //places = _.pluck(places, 'description');

                    if (!scope.isTrendscapeViewable()) {
                        return;
                    }

                    // remove time filter from trendscape
                    var params = angular.copy(scope.params);
                    delete params.filters.time;
                    params = serializer.generate(angular.extend({q: scope.params.q}, params));

                    return $state.go('trendscape-search', params);
                };

                scope.allNumShown = 3;
                scope.contentLoader = new Monitor();
                scope.filterLoader = new Monitor();
                scope.sources = {};

                angular.forEach(Api.search, function (resource, key) {
                    scope.sources[key] = new AjaxList(resource, {pageSize: 12, contiguous: false});
                });

                scope.$watch('params', _.debounce(newSearch, 1000), true);

                reset();
            }
        };
    }
]);
